/**
 * JSON Minify Tool
 * 
 * Minifies JSON by removing whitespace.
 */

import { SEMANTIC_TYPES } from '@/detectors/semanticTypes';
import { ToolError } from '@/engine/errors/ToolError';
import type { ITransformerTool } from '@/interfaces/ITool';
import { parseJsonLenient } from '@/lib/jsonParser';

export const JsonMinifyTool: ITransformerTool = {
  id: 'json-minify',
  name: 'JSON Minify',
  description: 'Minify JSON by removing all whitespace',
  version: '1.0.0',
  type: 'transformer',
  category: 'Formatters & Minifiers',
  keywords: ['json', 'minify', 'compress', 'compact'],

  supportedInputTypes: [SEMANTIC_TYPES.JSON],
  outputType: SEMANTIC_TYPES.JSON,

  attributes: [],

  supportsInput(input: string, detectedType?: string): boolean {
    if (detectedType !== 'JSON') return false;
    try {
      parseJsonLenient(input);
      return true;
    } catch {
      return false;
    }
  },

  async transform(input: string): Promise<string> {
    try {
      const parsed = parseJsonLenient(input);
      return JSON.stringify(parsed);
    } catch (e) {
      const error = e as Error;
      throw ToolError.validation(`Invalid JSON: ${error.message}`);
    }
  },
};

